<script>
export default {
	name: 'show',
}
</script>

<template>
	<div>22</div>
</template>

<style scoped></style>
